import { useMembersQuery } from '@platform/state/api';
import type { IWorkspaceCountProps } from './IWorkspaceCountProps';

/** Кількість учасників робочого простору (GET /workspaces/{id}/members) — клітинка таблиці «Робочі простори». */
export function WorkspaceMembersCount({ ws }: IWorkspaceCountProps) {
  const { data } = useMembersQuery(ws);
  return <span className="sp-mono">{data ? data.length : '…'}</span>;
}
